import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "./ReusableCarousel.css";
import { useNavigate } from "react-router-dom";

const ReusableCarousel = () => {
  const navigate = useNavigate();

  const banners = [
    {
      image: "/assets/images/banner/new-bg-11.png",
      link: "donation/Maddileti-Swamy-Temple-Ahobilam",
    },
    {
      image: "/assets/images/banner/new-bg-11.png",
      link: "donation/Rathayatra-Annadan-Puri-2025",
    },
    {
      image: "/assets/images/banner/new-bg-11.png",
      link: "donation/Feed-Monkey-Vrindavan",
    },
  ];

  const handleClick = (link) => {
    navigate(link);
  };

  return (
    <section className="app_header">
      <Swiper
        modules={[Autoplay, Navigation]}
      autoplay={false}
      loop={false}
      // navigation
      >
        {banners.map((item, index) => (
          <SwiperSlide key={index}>
            <div
              className="banner-slide"
              style={{
                backgroundImage: `url(${item.image})`,
              }}
            //  onClick={() => handleClick(item.link)}
            ></div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default ReusableCarousel;
